{
  "MENU": {
    "MEMBERSHIP": "Membership",
    "EVERYDAY_CARE": "{{tenant}} Plus: For Everyday Care",
    "HEALTH_SHARE_FOR_LARGE": "HealthShare: For Large Medical Expenses",
    "FOR_MEMBERS": "For our members",
    "EMPLOYERS_BENEFITS": "Employers Benefits",
    "Brokers Benefits": "Brokers Benefits",
    "OFFICE_VISITS": "Office Visits",
    "VIRTUAL_URGENT_CARE": "Virtual Urgent Care",
    "MENTAL_HEALTH": "Mental Health Counseling",
    "PHARMACY": "Pharmacy",
    "DENTAL_CARE": "Dental Care",
    "VISION_CARE": "Vision Care",
    "IMAGING": "Imaging",
    "LAB_TESTS": "Lab Tests",
    "PROCEDURES_SURGERIES": "Procedures & Surgeries",
    "HEALTH_SHARE": "Healthshare",
    "RESOURCES": "Resources",
    "FAQ_AND_VIDEOS": "FAQs & Videos",
    "VIDEOS": "Videos",
    "BLOGS": "Blogs",
    "FAQS": "FAQs",
    "ABOUT_US": "About Us",
    "CONTACT_US": "Contact Us",
    "FOR_EMPLOYERS": "For Employers",
    "FOR_BROKERS": "For Brokers",
    "REGISTER": "Join Now",
    "REGISTER_INFO": "Don’t have an account?",
    "MEMBERLOGIN": "Member login",
    "ACCOUNT": "My Account",
    "FAMILY": "Family Info",
    "Wallet": "Wallet",
    "Dashboard": "Visit Dashboard",
    "LOGOUT": "Logout",
    "LOGIN": "Login",
    "LOGIN_INFO": "Already have an account?"
  },
  "FOOTER": {
    "APPINFOTITLE": "Take control of your healthcare with our easy to use app",
    "DESCRIPTION": "Enjoy unlimited healthcare savings at {{tenant}}. Our memberships are affordable and easy to access with transparent pricing.",
    "SIGNUP_AS": "Sign up as",
    "EMPLOYERS": "Employers",
    "PROVIDER": "Provider",
    "DISCLAIMER_TITLE": "Disclaimer:",
    "DISCLAIMER_DESCRIPTION": "We are not health insurance. Our membership program offers discounted healthcare services for a monthly fee. Members pay providers directly at the time of service. This is not a substitute for insurance and does not meet ACA requirements."
  },
  "LOGINFORM": {
    "TITLE": "Log in to your account",
    "DESCRIPTION": "Welcome back! Please enter your details.",
    "LABEL_EMAIL": "Email",
    "EMAIL_ERROR": "Please enter your email",
    "EMAIL_VALID": "Please enter a valid email.",
    "LABEL_PASSWORD": "Password",
    "PASSWORD_ERROR": "Please enter your password",
    "LABEL_FORGOT": "Forgot password?",
    "LABEL_REMEMBER": "Remember me",
    "LABEL_SUBMIT": "Sign in",
    "INVALID_CREDENTIALS_ERROR": "Invalid credentials!",
    "NO_ACCOUNT": "Don’t have an account?",
    "BECOME_MEMBER": "Join Now",
    "CONTENT": "Welcome!",
    "PARA": "The {{tenant}} member portal is your one-stop-shop for accessing all of your health care services and benefits. ",
    "CONTENT_MEMBER": "Set up and access your member account: ",
    "MDISCRIPTION": "If you are a new member and have not set up your online account, <a href='/' class='start-here-link'>start here</a>.  You will be guided to complete your member profile and if applicable, designate your dependents. ",
    "LOGIN_MEMBER": "Log In:",
    "LOGINPARA": "Enter your email and password and Sign In to access your member dashboard. All included services in your {{tenant}} membership will be listed on your dashboard. "
  },
  "FORGOTPASSWORDFORM": {
    "EMAIL_FIELD": "Email",
    "EMAIL_REQUIRED": "Please enter your email.",
    "EMAIL_PATTERN": "Please enter a valid email."
  },
  "REGISTERFORM": {
    "HEADING": "Signup for {{tenant}}",
    "SUB_HEADING": "Become Our Member",
    "FIRST_NAME": "First Name",
    "FIRST_NAME_ERROR": "Please enter first name",
    "LAST_NAME": "Last Name",
    "LAST_NAME_ERROR": "Please enter last name",
    "NAME_HELPER_TEXT": "This will appear on your membership card",
    "PASSWORD_HELPER_TEXT": "Use 12 or more characters with a mix of letters (upper & lower), numbers, and symbols.",
    "HOW_DID_YOU_HEAR": "How did you hear about us?",
    "EMAIL": "Email",
    "EMAIL_PLACEHOLDER": "johndoe@abc.com",
    "EMAIL_ERROR": "Please enter your email",
    "EMAIL_VALID": "Please enter a valid email.",
    "PHONE": "Phone",
    "PHONE_ERROR": "Please enter your phone number",
    "PHONE_ERROR_LENGTH": "Length must not be greater than 10",
    "DOB": "Date of Birth",
    "DOB_ERROR": "Please enter date of birth",
    "DOB_AGE_ERROR": "Age should be greater than 18",
    "FUTURE_DATE": "Cannot be a future date",
    "CHILD_DOB_VALID": "Child should not be older than 26",
    "DOB_VALID": "Please enter date in proper pattern",
    "GENDER": "Gender",
    "GENDER_ERROR": "Please select gender",
    "REFERRAL": "How did you hear about us?",
    "REFERRAL_ERROR": " Please select How did you hear about us?",
    "TIMEZONE": "Time zone",
    "TIMEZONE_ERROR": "Please select your timezone.",
    "PASSWORD": "Password",
    "PASSWORD_ERROR": "Please enter password",
    "PASSWORD_ERROR_PATTERN": "Password should be Atleast one upper case letter, one lower case letter, one Number , one Special Character, Minimum 12 and Maximum 20 characters in limit",
    "PASSWORD_MINIMUM_LENGTH": "Length should be atleast 8 characters",
    "PASSWORD_REQUIREMENTS": "Use 12 or more characters with a mix of letters (upper & lower), numbers, and symbols.",
    "CONFIRM_PASSWORD": "Confirm Password",
    "CONFIRM_PLACEHOLDER": "Re enter-Password",
    "CONFIRM_PASSWORD_ERROR": "Please confirm your password",
    "CONFIRM_PASSWORD_MATCH": "Passwords do not match",
    "TERMS_VALIDATION": "Please agree to terms and conditions.",
    "SIGN_UP_BTN": "Sign Up & Proceed to Pay",
    "CREATE_ACC_TITLE": "Create your account",
    "CONFIRM_EMAIL_TITLE": "Confirm your email",
    "CREATE_ACC_DESC": "Complete the online registration form with your personal details to create your {{tenant}} member account. This will enable you to manage your plan, dependents, and services.",
    "CONFIRM_EMAIL_DESC": "After registering, check your email inbox for a confirmation message. Click the link to verify and activate your account.",
    "LOGIN_DESC": "After email confirmation, return to the login page with your email and password to access your member dashboard. If you already have an account, <a href='/' class='start-here-link'>click here</a> to log in."
  },
  "RESETPASSWORD": {
    "HEADING": "Create Password",
    "SUB_HEADING": "Select a new password for future logins.",
    "PASSWORD_REQUIRED": "Please enter your password",
    "CONFIRM_PASSWORD_REQUIRED": "Please enter your confirm password"
  },
  "ACTIVATEACCOUNT": {
    "TITLE": "Set Up Your Login",
    "DESCRIPTION": "Enter the email address and password you'll use to sign in to your account.",
    "EMAIL_LABEL": "Email Address",
    "EMAIL_PLACEHOLDER": "yourname@example.com",
    "EMAIL_REQUIRED": "Email address is required",
    "EMAIL_VALID": "Please enter a valid email address",
    "EMAIL_EXAMPLE_INVALID": "Please enter your own email address; example.com is not allowed.",
    "EMAIL_HINT": "You will use this email to login to your account.",
    "PASSWORD_LABEL": "Password",
    "PASSWORD_PLACEHOLDER": "Create a password",
    "PASSWORD_REQUIRED": "Password is required",
    "PASSWORD_PATTERN": "Use at least 12 characters, including letters, numbers, and symbols",
    "CONFIRM_LABEL": "Confirm Password",
    "CONFIRM_PLACEHOLDER": "Re-enter your password",
    "CONFIRM_REQUIRED": "Please confirm your password",
    "CONFIRM_MISMATCH": "Passwords do not match",
    "PASSWORD_HINT": "Use at least 12 characters, including a combination of letters, numbers, and symbols.",
    "SUBMIT_BTN": "Set Up Account",
    "SUPPORT_PREFIX": "Having trouble?",
    "SUPPORT_LINK": "Contact support",
    "MEMBERSHIP_TITLE": "Activate Your Membership",
    "MEMBERSHIP_DESC": "Your employer has enrolled you in healthcare benefits. Complete these steps to access your dashboard.",
    "HOW_IT_WORKS": "How it works",
    "STEP_1": "Add your email address",
    "STEP_2": "Create a secure password",
    "STEP_3": "Access your dashboard",
    "VERIFYING_TITLE": "Verifying your activation link...",
    "SETTING_UP_TITLE": "Setting up your account...",
    "PLEASE_WAIT": "Please wait a moment...",
    "SUCCESS_TITLE": "Your Account Is Ready",
    "SUCCESS_DESC": "Your account is ready. You can now sign in using your email address and password.",
    "SIGN_IN_BTN": "Sign In Now",
    "EXPIRED_TITLE": "Verification Link Expired",
    "EXPIRED_DESC": "The link in your text message has expired. Verification links are valid for 72 hours.",
    "EXPIRED_NOTE_TITLE": "Link has expired",
    "EXPIRED_NOTE_DESC": "For your security, verification links expire after 72 hours. Request a new activation link to continue setting up your account.",
    "RESEND_BTN": "Request New Activation Link",
    "EXPIRED_SIDE_TITLE": "Need a new activation link?",
    "EXPIRED_SIDE_DESC": "Request a new link and we'll send it to your registered phone number so you can complete your WoW Health online account setup.",
    "WHAT_HAPPENS_NEXT": "What happens next",
    "NEXT_1": "We'll send a new activation link to your phone",
    "NEXT_2": "Open the link within 72 hours",
    "NEXT_3": "Add your email address",
    "NEXT_4": "Create your password",
    "LINK_SENT_TITLE": "New Activation Link Sent",
    "LINK_SENT_DESC": "A new activation link has been sent to your registered mobile number. Please check your messages and click the link within 72 hours.",
    "CLOSE_BTN": "Close",
    "ERROR_TITLE": "Something Went Wrong",
    "ERROR_DESC": "We were unable to complete your request. Please try again later.",
    "TRY_AGAIN_BTN": "Try Again",
    "SETUP_FAILED": "We were unable to set up your account. Please try again."
  },
  "CONTACTUS": {
    "HEADING": "Get In Touch",
    "SUB_HEADING": "We are available to offer our support and respond to any inquiries that you may have. We are excitedly anticipating hearing from you.",
    "NAME": "Name",
    "NAME_ERROR": "Please enter name",
    "FIRST_NAME": "First Name",
    "FIRST_NAME_ERROR": "The field is required.",
    "LAST_NAME": "Last Name",
    "LAST_NAME_ERROR": "The field is required.",
    "SUBJECT": "Subject",
    "SUBJECT_PLACEHOLDER": "How can we help you?",
    "SUBJECT_ERROR": "The field is required.",
    "EMAIL": "Email Address",
    "EMAIL_ONLY": "Email",
    "EMAIL_PLACEHOLDER": "Johndoe@gmail.com",
    "EMAIL_ERROR": "The field is required.",
    "EMAIL_VALID": "Please enter a valid email.",
    "PHONE": "Phone Number",
    "PHONE_PLACEHOLDER": "9832314233",
    "PHONE_ERROR": "The field is required.",
    "MESSAGE": "Message",
    "MESSAGE_ERROR": "Please enter message",
    "MESSAGE_PLACEHOLDER": "Enter your thoughts here",
    "TERMS_VALIDATION": "Please agree to terms and conditions.",
    "SEND_MESSAGE": "Send Message",
    "SUCCESS_MSG": "Thank you for your message it has been sent"
  },
  "PROFILE": {
    "HEADING": "Hi",
    "SUBHEADING": "Welcome to your {{tenant}} Dashboard",
    "TOUR": {
      "HEADING_ONE": "Welcome to {{tenant}}",
      "HEADING": "How it works",
      "DESCRIPTION": "Check this video if you need help navigating the dashboard",
      "RESTART_TOUR": "Restart Tour",
      "WATCH_VIDEO": "Watch Video",
      "DESCRIPTION_ONE": "Take a quick tour to see how you can easily access all your healthcare benefits.",
      "START_TOUR": "Start Tour",
      "SKIP_TOUR": "Skip Tour"
    },
    "STEP1": {
      "HEADING": "Add your personal information",
      "SUB_HEADING": "Enter your address, zip code, phone number, etc.",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "PHONE": "Phone number",
      "DOB": "Date of Birth",
      "GENDER": "Gender",
      "ADDRESS": "Address",
      "CITY": "City",
      "STATE": "State",
      "COUNTRY": "Country",
      "ZIPCODE": "Zip Code",
      "TIMEZONE": "Time Zone",
      "SUBMIT_BTN": "Submit",
      "CONTINUE_BTN": "Save & Proceed",
      "FINISH_BTN": "Finish"
    },
    "STEP2": {
      "HEADING": "Choose your plan type",
      "SUB_HEADING": "Select a plan type to proceed",
      "SELECT_MEMBERSHIP_TYPE": "Select the membership type",
      "INDIVIDUAL": "Individual",
      "SPOUSE": "Spouse",
      "FAMILY": "Family",
      "CHILDREN": "Children",
      "SUBMIT_BTN": "Submit",
      "CONTINUE_BTN": "Save & Proceed",
      "FINISH_BTN": "Finish"
    },
    "STEP3": {
      "HEADING": "Add your spouse information",
      "SUB_HEADING": "Add name, email, date of birth, etc",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "DOB": "Date of Birth",
      "GENDER": "Gender",
      "SUBMIT_BTN": "Submit",
      "CONTINUE_BTN": "Save & Proceed",
      "FINISH_BTN": "Finish",
      "ACCESS": "Allow account access to spouse",
      "TOOLTIP": "When access is granted to both parents, they can jointly manage this minor account. Otherwise, only the primary parent account will have access to it."

    },
    "STEP4": {
      "HEADING": "Add your child(ren) information",
      "SUB_HEADING": "Add your child(ren) information",
      "ACCESS": "Allow account access to spouse",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "DOB": "Date of Birth",
      "GENDER": "Gender",
      "SUBMIT_BTN": "Submit",
      "CONTINUE_BTN": "Save & Proceed",
      "FINISH_BTN": "Finish",
      "ADD_ANOTHER_BTN": "Add Another",
      "REMOVE_BTN": "Delete"
    },
    "SUCCESS": {
      "HEADING": "Thank you!",
      "CONTENT": "You have successfully updated your profile. Please note that your membership will start on {{date}}. After that date, you will be able to fully access all of the membership services and benefits",
      "BTN_TEXT": "Go to Dashboard"
    },
    "ERROR": {
      "GENERIC": "This is required",
      "EMAIL": "Please enter a valid email.",
      "TOTAL_PHONE_LENGTH": "Phone number to have 10 digits"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Dashboard",
    "APPOINTMENTS": "Appointments",
    "MEMBERSHIPS": "Memberships",
    "RESOURCES": "Resources",
    "WALLET": "Wallet",
    "FAMILY_INFO": "Family Info",
    "ACCOUNT": "Account",
    "MYACCOUNT": "My Account",
    "VISITEWEB": "Visit Website",
    "LOGOUT": "Log Out"
  },
  "SEARCH_COMPONENT": {
    "BUTTON": "Search",
    "INFO": "We were unable to find any results for ",
    "HELPTEXT": "Please check spelling and pick from drop down."
  },
  "DASHBOARD": {
    "BTN_TEXT": "Get {{tenant}} Membership",
    "WELLNESS": {
      "NEED_HELP": "Need Help?",
      "LEARN_MORE": "Learn more",
      "WELLNESS_REWARD": "Wellness Reward"
    }
  },
  "SAVE": "Save payment method",
  "tenant": "{{tenant}} ENGLISH",
  "LOW_BALANCE": "Low Balance in {{tenant}} Wallet",
  "GO_BACK": "Go back to {{tenant}}",
  "image": "assets/tenant-assets/images/healtthshare-main.webp",
  "homepage_title": "Home Page Content",
  "APP_TITLE": "{{tenant}}",
  "GO_BACK_BTN": "Go Back",
  "CONTINUE_BTN": "Continue",
  "TRUSTED_PARTNERS": "Our Trusted Partners",
  "EMAIL_SENT": "Email has been sent successfully!",
  "CVV_ERR": "CVV should be between 3 to 4 numbers",
  "CARDHOLDER_ERR": "Card display name should be in 'Fullname' format",
  "ZIPCODE_REQUIRED": "Zipcode is required",
  "ZIPCODE_ERR": "Zipcode should be of 5 numbers",
  "EXPIRY_ERR": "Please Enter valid Expiry Date",
  "CARDNUMBER_ERR": "Card Number should be between 13 to 16 numbers",
  "DELETE": "Delete",
  "ALREADY_MEMBER": "Already a member?",
  "SIGN_IN": "Sign in",
  "MEMBERSHIP_WARNING": "Important! Regarding your membership start date",
  "PAYMENT_DETAILS": "Payment Details",
  "EXPIRY_FUTURE_ERR": "Expiry must be in the future.",
  "SAVE_CARD": "Use this card for future transactions",
  "SECURED_PAYMENT": "This payment is secured with SSL encryption.",
  "ALERTBOXCOMPONENT": {
    "HEADING": "Important! Regarding your membership start date",
    "SUBHEADING1": "Please note that your membership will start on",
    "SUBHEADING2": "After that date, you will be able to fully access all of the membership services and benefits."
  },
  "FAMILY_INFO": {
    "ADD_NEW_MEMBERSHIP": "Add New Member",
    "ADD_NEW_MEMBER": "Add a New Member",
    "ADD_NEW_MEMBER_DESC": "Add a new member and link them directly to the selected membership.",
    "FORM": {
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "GENDER": "Gender",
      "RELATION": "Relation",
      "DATE_OF_BIRTH": "Date Of Birth",
      "EMAIL": "Email",
      "SPOUSE_ACCESS": "Allow account access to spouse",
      "TOOLTIP": "When access is granted to both parents, they can jointly manage this minor account. Otherwise, only the primary parent account will have access to it.",
      "SAVE_BTN": "Save",
      "DISCARD_BTN": "Cancel",
      "ERROR": {
        "GENERIC": "This field is required.",
        "EMAIL": "Please enter a valid email.",
        "SPOUSE_DOB_VALID": "Spouse should be older than 18",
        "CHILD_DOB_VALID": "Child should not be older than 26",
        "DOB_PATTERN": "Pattern should be valid",
        "FUTURE_DATE": "Cannot be a future date"
      }
    }
  },
  "TOUR": {
    "STEP1": {
      "TITLE": "Experience {{tenant}} in Action",
      "TEXT": "Prefer a quick walkthrough instead? Watch this short video to see how  {{tenant}} works and how you can get the most out of it."
    },
    "STEP2": {
      "TITLE": "Your Dashboard, Your Control",
      "TEXT": "This is your main dashboard. Simply tap on the service you need. "
    },
    "STEP3": {
      "TITLE": "Book & Manage Appointments",
      "TEXT": "View, schedule, and manage all your past and upcoming appointments. No more paperwork hassle."
    },
    "STEP4": {
      "TITLE": "Flexible Membership Options",
      "TEXT": "Easily update your membership based on your needs. Your healthcare your choice."
    },
    "STEP5": {
      "TITLE": "All Answers in One Place",
      "TEXT": "Got questions? Visit the Resources tab for instant help and detailed information about {{tenant}}."
    },
    "NEXT_BTN": "Next",
    "DONE_BTN": "Got It! Let’s Go"
  },
  "WARNINGMODAL" : {
    "HEADING" : "Your Healthcare Benefits Are Available at ",
    "POINT1" : "Please click the button below to visit ",
    "POINT2" : "Log in to your account with the same username and password",
    "POINT3" : "Access your dashboard",
    "POINT4" : "Pick any healthcare service that you need",
    "BTNTXT" : "Go to"
  },
  "INCOMPLETE_PROFILE" : {
    "HEADING" : "Important! Regarding Incomplete Membership Profile",
    "DETAIL_PRIMARY" : "Your profile is incomplete. Complete it to access your healthcare services.",
    "DETAIL_SECONDARY" : "The primary member’s profile is incomplete. Services are unavailable until it’s updated.",
    "COMPLETE_PROFILE_BUTTON" : "Complete Profile",
    "CONTACT_SUPPORT_BUTTON" : "Contact Support"
  }
}